import React from "react";
import { Route, Switch, Redirect, useParams } from "react-router-dom";

import CardDashboard, { CreditReport } from "components/Pages/Dashboard";
import Login from "components/Pages/Login";
import SignUp from "components/Pages/Login/SignUp";
import PasswordRecovery from "components/Pages/Login/PasswordRecovery";
import ConfirmPassword from "components/Pages/Login/ConfirmPassword";
import BoostCheckoutRedirect from "components/Pages/Boost/BoostCheckoutRedirect";
import Payments from "components/Pages/Payments";
import Referrals from "components/Pages/Referrals";
// import Rewards from "components/Pages/Rewards";
import Home from "components/Pages/Home";
import Settings from "components/Pages/Settings";
import Statements from "components/Pages/Statements";
import Transactions from "components/Pages/Transactions";
import Issuing from "components/Pages/Issuing";
import More from "components/Pages/More";
import Support from "components/Pages/Support";
import Terminate from "components/Pages/Terminate";
import Admin from "components/Pages/Admin";
import GodView from "components/Pages/Admin/GodView";
import UserView from "components/Pages/Admin/User/UserView";
import CustomerSupport from "components/Pages/CustomerSupport";
import SupportalUserView from "components/Pages/CustomerSupport/SupportalUserView";
import FraudView from "components/Pages/Admin/FraudView";
import Notifications from "components/Pages/Notifications";
import DisputeView from "components/Pages/Admin/DisputeView";
import AllDisputes from "components/Pages/Admin/AllDisputes";
import AccountReview from "components/Pages/Admin/AccountReview";
import CreditReportingDashboard from "components/Pages/Admin/CreditReporting/CreditReportingDashboard";
import CreditReportingUserSearch from "components/Pages/Admin/CreditReporting/CreditReportingUserSearch";
import CreditMonitoringDashboard from "components/Pages/Dashboard/CreditMonitoringDashboard";
import Boost from "components/Pages/Boost/Boost";
import TomoBoostConfirm from "components/Pages/Login/TomoBoostConfirm";
import BoostPricingForUpgrade from "components/Pages/Boost/components/BoostPricingForUpgrade";
import PostStripeRedirect from "components/Pages/Login/PostStripeRedirect";
import NotFound from "components/Pages/Error/NotFound";
import TomoIQPage from "components/Pages/Dashboard/TomoIQ";
import MarketingV1 from "./Marketing/V1";
import MarketingV2 from "./Marketing/V2";
import PrivateRoute from "./AuthRoutes/Private";
import PublicRoute from "./AuthRoutes/Public";
import InternalRoute from "./AuthRoutes/Internal";
import {
  ACTIVITY,
  CARD,
  DASHBOARD,
  MORE,
  PAYMENTS,
  REFERRALS,
  // REWARDS,
  NOTIFICATIONS,
  SETTINGS,
  STATEMENTS,
  SUPPORT,
  TERMINATE,
  CREDIT_MONITORING,
  TOMO_BOOST,
  TOMO_ISSUING,
  SUPPORTAL,
  TOMO_IQ,
  CREDIT_REPORT,
} from "./pageConfig";

const AdminUserRoute = () => {
  const { user } = useParams();
  return (
    <Redirect
      to={{
        pathname: "/admin/god/user",
        search: `?email=${encodeURIComponent(user)}`,
      }}
    />
  );
};

const SupportalUserRoute = () => {
  const { user } = useParams();
  return (
    <Redirect
      to={{
        pathname: `${SUPPORTAL.path}/user`,
        search: `?email=${encodeURIComponent(user)}`,
      }}
    />
  );
};

const AppRoutes = () => (
  <Switch>
    <Route
      sensitive
      path="/:anything*([A-Z]):anything*/"
      render={(props) => (
        <Redirect to={`${props.location.pathname.toLowerCase()}`} />
      )}
    />
    <PublicRoute exact path="/login" component={Login} />
    <PublicRoute exact path="/signup" component={SignUp} />
    <PublicRoute exact path="/passwordrecovery" component={PasswordRecovery} />
    <PublicRoute exact path="/confirmpassword" component={ConfirmPassword} />
    <PublicRoute
      exact
      path="/boost/checkout"
      component={BoostCheckoutRedirect}
    />
    <PublicRoute
      exact
      path="/boost/pricing"
      component={BoostCheckoutRedirect}
    />
    <PrivateRoute
      exact
      path={TOMO_BOOST.path}
      component={Boost}
      config={TOMO_BOOST}
    />
    <PrivateRoute
      exact
      path={TOMO_IQ.path}
      component={TomoIQPage}
      config={TOMO_IQ}
      noPadding
    />
    <PrivateRoute
      exact
      path="/boost/credit-hack"
      component={BoostPricingForUpgrade}
      config={TOMO_BOOST}
    />
    <PrivateRoute
      exact
      path="/boost/upgrade-membership"
      component={BoostPricingForUpgrade}
      config={TOMO_BOOST}
    />
    <PublicRoute
      exact
      path="/tomo-boost-confirm"
      component={TomoBoostConfirm}
      noPadding
    />
    <PublicRoute
      exact
      path="/stripe-redirect"
      component={PostStripeRedirect}
      noPadding
    />
    <PrivateRoute
      exact
      path={CREDIT_MONITORING.path}
      component={CreditMonitoringDashboard}
      config={CREDIT_MONITORING}
    />
    {/* <PrivateRoute
      exact
      path="/dispute-center/new"
      component={NewDispute}
      noPadding
    /> */}
    <PrivateRoute
      exact
      path="/credit-report"
      component={CreditReport}
      noPadding
      config={CREDIT_REPORT}
    />
    <PrivateRoute
      exact
      path={DASHBOARD.path}
      component={Home}
      config={DASHBOARD}
    />
    <PrivateRoute
      exact
      path={CARD.path}
      component={CardDashboard}
      config={CARD}
    />
    <PrivateRoute
      exact
      path={TOMO_ISSUING.path}
      component={Issuing}
      config={TOMO_ISSUING}
    />
    <PrivateRoute
      exact
      path="/activity*"
      component={Transactions}
      config={ACTIVITY}
    />
    <PrivateRoute
      exact
      path="/payments*"
      component={Payments}
      config={PAYMENTS}
    />
    <PrivateRoute
      exact
      path={REFERRALS.path}
      component={Referrals}
      config={REFERRALS}
    />
    {/* <PrivateRoute exact path={REWARDS.path} component={Rewards} config={REWARDS}/> */}
    <PrivateRoute
      exact
      path={SETTINGS.path}
      component={Settings}
      config={SETTINGS}
    />
    <PrivateRoute
      exact
      path={STATEMENTS.path}
      component={Statements}
      config={STATEMENTS}
    />
    <PrivateRoute exact path={MORE.path} component={More} config={MORE} />
    <PrivateRoute
      exact
      path={SUPPORT.path}
      component={Support}
      config={SUPPORT}
    />
    <PrivateRoute
      exact
      path={TERMINATE.path}
      component={Terminate}
      config={TERMINATE}
    />
    <PrivateRoute
      exact
      path={NOTIFICATIONS.path}
      component={Notifications}
      config={NOTIFICATIONS}
    />
    <InternalRoute exact path="/admin" component={Admin} />
    <InternalRoute
      exact
      config={SUPPORTAL}
      path={SUPPORTAL.path}
      component={CustomerSupport} />
    <InternalRoute path="/marketing*" component={MarketingV1} />
    <InternalRoute path="/v2-marketing*" component={MarketingV2} />
    <InternalRoute exact path="/account-review" component={AccountReview} />
    <InternalRoute
      exact
      config={SUPPORTAL}
      path={`${SUPPORTAL.path}/user`}
      component={SupportalUserView}
    />
    <InternalRoute
      exact
      config={SUPPORTAL}
      path={`${SUPPORTAL.path}/user/:user`}
      component={SupportalUserRoute}
    />
    <InternalRoute exact path="/admin/god" component={GodView} />
    <InternalRoute exact path="/admin/god/user" component={UserView} />
    <InternalRoute exact path="/admin/god/user/:user" component={AdminUserRoute} />
    <InternalRoute exact path="/admin/god/fraud" component={FraudView} />
    <InternalRoute exact path="/admin/god/dispute" component={AllDisputes} />
    <InternalRoute
      exact
      path="/admin/credit-reporting"
      component={CreditReportingDashboard}
    />
    <InternalRoute
      exact
      path="/admin/credit-reporting/search"
      component={CreditReportingUserSearch}
    />
    <InternalRoute
      exact
      path="/admin/god/dispute/:disputeId"
      component={DisputeView}
    />

    <Route component={NotFound} />
  </Switch>
);

export default AppRoutes;
